import {
  createFetchClient,
  type FetchClient,
} from "@fluid-app/checkout-api-client";
import { env } from "@/env";
import Cookies from "js-cookie";
import { JWT_COOKIE, clearJwtCookies } from "@/lib/jwt-shop-scope";

function getCheckoutApiBaseUrl() {
  return env.NEXT_PUBLIC_FLUID_API_URL.replace(/\/api\/?$/, "");
}

const checkoutApiDefaultHeaders = { "x-fluid-client": "checkout" };

function handleCheckoutAuthError() {
  if (!Cookies.get(JWT_COOKIE)) return;

  clearJwtCookies();
  window.location.reload();
}

export function createCheckoutApiClient(jwt?: string | null): FetchClient {
  return createFetchClient({
    baseUrl: getCheckoutApiBaseUrl(),
    getAuthToken: () => jwt ?? Cookies.get(JWT_COOKIE) ?? null,
    defaultHeaders: checkoutApiDefaultHeaders,
    onAuthError: handleCheckoutAuthError,
  });
}

export function createPublicCheckoutApiClient(): FetchClient {
  return createFetchClient({
    baseUrl: getCheckoutApiBaseUrl(),
    defaultHeaders: checkoutApiDefaultHeaders,
  });
}
